import React, { useEffect, useState } from "react"

import { withLayout } from "./withLayout"
import { Meta } from "../Meta/Meta"
import Globals from "./Global"
import { Header } from "../Header/Header"
import { Dashboard } from "../Account/Dashboard/Dashboard"
import { Main } from "../Main/Main"
import { Footer } from "../Footer/Footer"
import { NewsletterPopup } from "../NewsletterPopup/NewsletterPopup"

export const Layout = withLayout(({ data, location, homepage, accountPage, children, title, routes, newsletter, product }): JSX.Element => {
  const [load, setLoad] = useState(false)
  useEffect(() => {
    const onPageLoad = () => {
      setLoad(true)
    }
    if (document.readyState === "complete") {
      onPageLoad()
    } else {
      window.addEventListener("load", onPageLoad)
      return () => window.removeEventListener("load", onPageLoad)
    }
  }, [])
  return (
    <>
      <Globals />
      <Meta data={data} url={location?.pathname} routes={routes} product={product} />
      {!homepage ? <Header title={title} location={location} fixed /> : null}
      <Main>{accountPage ? <Dashboard location={location}>{children}</Dashboard> : children}</Main>
      {load ? <Footer title={title} /> : null}
      {newsletter?.enabled && <NewsletterPopup newsletter={newsletter} />}
    </>
  )
})
